import { useState, useEffect } from 'react';

function useScrollbarWidth({ width = 'auto' }) {
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  useEffect(() => {
    // Check if we're in a browser environment
    if (typeof window !== 'undefined') {
      // Create a temporary div to measure the scrollbar
      const scrollDiv = document.createElement('div');
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.scrollbarWidth = width;
      scrollDiv.style.top = '-9999px';
      document.body.appendChild(scrollDiv);

      // Calculate the width difference
      const widthWithoutScroll = scrollDiv.clientWidth;
      const widthWithScroll = scrollDiv.offsetWidth;

      // Remove the temporary div
      document.body.removeChild(scrollDiv);

      // Set the scrollbar width
      setScrollbarWidth(widthWithScroll - widthWithoutScroll);

      // We only need to run this once when the component mounts
    }
  }, [width]); // Empty dependency array means it runs only once

  return scrollbarWidth;
}

export default useScrollbarWidth;
